import * as React from 'react';

import classNames from 'classnames';

import type { CmlContent } from 'bundles/cml';
import AdminDetails from 'bundles/discussions/components/AdminDetails';
import Like from 'bundles/discussions/components/Like';
import TranslationFailedNotification from 'bundles/ondemand-translation/components//TranslationFailedNotification';
import { TranslateContentButton } from 'bundles/ondemand-translation/components/TranslateContentButton';
import { TranslationContextProvider } from 'bundles/ondemand-translation/components/TranslationContextProvider';
import { TranslatedCMLViewer } from 'bundles/ondemand-translation/components/cml/TranslatedCMLViewer';

type CreatorProfile = {
  fullName: string;
  isSuperuser: boolean;
  courseRole: string;
  [key: string]: $TSFixMe;
};

type Reply = {
  createdAt?: number;
  creatorId?: number;
  isUpvoted?: boolean;
  id?: string;
  content?: CmlContent;
  upvoteCount?: number;
  childAnswerCount?: number;
  isFlagged?: boolean;
  creator: CreatorProfile;
  forumType?: string;
  topLevelForumAnswerId?: string;
  forumCommentId?: string;
  type?: string;
  order?: number;
  questionId?: string;
  highlighted?: boolean;
  hide?: boolean;
  flagDetails?: any;
  showEditor?: boolean;
  [key: string]: $TSFixMe;
};

type Props = {
  reply: Reply;
  replyLegendId?: string;
  isReadOnlyAfterSessionEnd?: boolean;
  toggleButton?: any;
  jumpLink?: any;
};

const replyPreviewClasses = classNames(
  'action-area',
  'horizontal-box',
  'align-items-vertical-center',
  'caption-text',
  'color-secondary-text'
);

const ReplyListItemActions = (props: Props) => {
  const { reply, replyLegendId, isReadOnlyAfterSessionEnd, toggleButton, jumpLink } = props;

  const contentClasses = classNames('reply-details', {
    flag: reply.flagDetails && reply.flagDetails.isActive,
  });

  return (
    <TranslationContextProvider>
      <div className={contentClasses}>
        <TranslatedCMLViewer cml={reply.content} enableTranslation />
      </div>
      <TranslationFailedNotification />

      <div className={replyPreviewClasses}>
        <Like post={reply} ariaDescribedBy={replyLegendId} isReadOnlyAfterSessionEnd={isReadOnlyAfterSessionEnd} />
        {reply.type === 'answer' && toggleButton}
        <TranslateContentButton eventingSectionName="discussion_prompt" />
        {jumpLink}
        <AdminDetails post={reply} />
      </div>
    </TranslationContextProvider>
  );
};

export default ReplyListItemActions;
